<template>
  <div class="h5-container">
    <van-nav-bar class="top-bar" title="首页"></van-nav-bar>
    <div class="container-item">
    <!-- 原有用户信息卡片 -->
    <van-card shadow="never" class="user-card">
      <template #desc>
        <div class="user-header">
          <van-image round class="user-header-img"
                     :src="avatarPic"
          >
          </van-image>
          <div class="user-info">
            <h3>{{userInfo.nickName}}</h3>
            <h3>{{ userInfo.userName ? desensitizePhone(userInfo.userName) : '**** **** ****' }}</h3>
            <!--            <van-tag color="#D4AF37" text-color="#000" size="mini">钻石VIP</van-tag>-->
          </div>
          <van-button type="primary" size="mini">注册{{userInfo.registerDay || 1}}天</van-button>
        </div>
        <span>{{userInfo.signature}}</span>
<!--        <div class="stats">-->
<!--          <div class="stat-item">-->
<!--            <p class="value">0</p>-->
<!--            <p class="label">可用积分</p>-->
<!--          </div>-->
<!--          <div class="stat-item" @click="onChangeSearch('/app_benefits')">-->

<!--            <p class="label">官方权益</p>-->
<!--            <p class="value">{{equitiesSize}}个</p>-->
<!--          </div>-->
<!--        </div>-->
      </template>
    </van-card>

    <!-- 球杆激活按钮 -->
    <van-button v-if="userType === '01'" class="club-activate-btn" block @click="onChangeSearch('/app_activation')">球杆绑定</van-button>

    <!--   普通会员   -->
    <div class="func-grid" v-if="userType === '01'">
      <div class="grid-item-search grid-item-left" @click="onChangeSearch('/app_search')">
        <span class="grid-text">真伪查询</span>
      </div>
      <div class="grid-item-myclub grid-item-right" @click="onChangeSearch('/app_myClub')">
        <span class="grid-text">我的球杆</span>
      </div>
      <div class="grid-item-register grid-item-left" @click="onChangeSearch('/app_after')">
        <span class="grid-text">售后申请</span>
      </div>
      <div class="grid-item-step grid-item-right" @click="onChangeSearch('/app_step')">
        <span class="grid-text">售后进度</span>
      </div>
    </div>
    <!--   代理商   -->
    <div class="func-grid" v-if="userType === '02'">
      <div class="grid-item-search grid-item-left" @click="onChangeSearch('/app_search_dls')">
        <span class="grid-text">真伪查询</span>
      </div>
      <div class="grid-item-step grid-item-right" @click="onChangeSearch('/unbind')">
        <span class="grid-text">球杆解绑</span>
      </div>
      <div class="grid-item-register grid-item-left" @click="onChangeSearch('/app_benefits')">
        <span class="grid-text">权益申请</span>
      </div>
      <div class="grid-item-sale-manage grid-item-right" @click="onChangeSearch('/sale_manage')">
        <span class="grid-text">销售管理</span>
      </div>
      <!-- 券码核销：跳转扫码核销页 -->
      <div class="grid-item-verify" @click="onChangeSearch('/app_scan')">
        <span class="grid-text">券码核销</span>
      </div>
    </div>

      <!--   销售   -->
      <div class="func-grid" v-if="userType === '03'">
        <div class="grid-item-step grid-item-left" @click="onChangeSearch('/sale_list')">
          <span class="grid-text">申请分销返利</span>
        </div>
      </div>

      <!-- 公告入口 -->
      <div class="notice-entry" @click="showNotice = true">
        <van-icon name="bell" />
        <span>售后公告</span>
      </div>
    </div>

    <!-- 公告弹窗 -->
    <van-popup v-model="showNotice" position="center" :style="{ width: '90%', maxWidth: '600px' }">
      <div class="notice-content">
        <div class="notice-header">
          <h3>售后公告</h3>
          <van-icon name="cross" @click="showNotice = false" />
        </div>
        <div class="notice-body">
          <p><strong>官方售后服务热线：</strong><a href="tel:18716016100" class="tel-link">18716016100</a></p>
          <p><strong>服务时段：</strong>周一至周五 8：30-12：00，13：00-17：30，周六周日及法定节假日休息</p>
          <p>非服务时间来电，系统将记录您的咨询信息，待正常上班后工作人员将第一时间回访解答，敬请耐心等候。</p>
        </div>
        <van-button block type="primary" @click="showNotice = false">我知道了</van-button>
      </div>
    </van-popup>
  </div>
</template>


<script>
import '@/assets/css/mobileGlobal.scss';
import {memberEquities, memberInformation} from "@/api/mine";
import {Dialog} from "vant";
import defaultAvatar from "@/assets/img/h5/avatar-default.png";
export default {
  name: 'UserInfoCard',
  data() {
    return {
      defaultAvatar: defaultAvatar,
      // topPicSrc: require("@/assets/img/company/chairman.png"),
      userInfo:{},
      avatarPic:'',
      userType: '', //用户类别：01-会员、02-代理商、00-后台用户
      equitiesSize: 0,
      showNotice: false,
    };
  },
  created() {
    this.getUserInfo();
    // this.memberEquities();
  },
  mounted() {
    this.showNotice = true;
  },
  methods: {
    //查询权益个数
    async memberEquities(){
      try {
        const res = await memberEquities();
        console.log(92,res.data);
        if (res.code === 200 && res.data) {
          console.log(94,res.data.equities);
          this.equitiesSize = res.data.equities.length || 0;
        } else {
          this.equitiesSize = 0;
        }
      } catch (err) {
        this.equitiesSize = 0;
      }
    },

    // 手机号脱敏处理
    desensitizePhone(phone) {
      if (!phone || phone.length !== 11) return phone;
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    //跳转
    onChangeSearch(path) {
      this.$router.push(path);
    },
    // 获取用户信息回显（
    async getUserInfo() {
      try {
        const res = await memberInformation();
        if (res.code === 200 && res.data) {
          // 回显用户信息
          this.userInfo =res.data;

          this.userType = res.data.userType;
          if (this.userInfo && this.userInfo.avatar) {
            this.avatarPic = this.userInfo.avatar.url ||defaultAvatar;
          }else{
            this.avatarPic =defaultAvatar;
          }
        } else if(res.code !== 401){
          // token存在但账号已失效（如账号被删除）：提示后清除本地登录态并回到登录页
          Dialog.alert({ title: "提示", message: res.returnMsg || '登录状态已失效，请重新登录' }).then(() => {
            this.$store.dispatch('logout');
            this.$router.replace('/app_login');
          });
        }
      } catch (err) {
        Dialog.alert({ title: "错误", message: "请稍后重试" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
$gold: #D4AF37;
$dark-bg: #1A1A1A;
$gutter: 30px; // 四宫格间距，可统一调整

::v-deep .van-image__img{
  object-fit: cover;
}
::v-deep .van-card{
  @media (min-width: 768px) {
    padding: 20px 80px;
  }
}
::v-deep .van-card__content{
  min-height:0;
}
.h5-container {
  background: $dark-bg;
  min-height: 100vh;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);;
}
.container-item {
  padding: 0 16px;
  padding-bottom: 60px;
  @media (min-width: 768px) {
    padding-bottom: 100px;
  }
}

.user-card {
  margin: 16px 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #222 0%, #000 100%);
  color: #fff;
  @media (min-width: 768px) {
    border-radius: 12px;
    margin: 16px 0;
  }

}
.user-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px;
  @media (min-width: 768px) {
    margin: auto 0;
  }
  h3 {
    margin: 0 0 4px 0;
    font-size: 14px;
    color: #fff;
    @media (min-width: 768px) {
      font-size: 24px;
    }
  }
}
.user-header-img{
  width: 48px;
  height: 48px;
  @media (min-width: 768px) {
    width: 100px;
    height: 100px;
  }
}
::v-deep .van-button{
  @media (min-width: 768px) {
    height: 60px;
    font-size: 24px;
  }
}
.user-info {
  flex: 1;
  margin: 0 12px;
}
.stats {
  display: flex;
  justify-content: space-around;
  padding-top: 16px;
  border-top: 1px solid rgba($gold, 0.2);
  .stat-item {
    text-align: center;
    .value {
      margin: 0;
      font-size: 16px;
      color: $gold;
    }
    .label {
      margin: 0;
      font-size: 12px;
      color: #fff;
    }
  }
}

.club-activate-btn {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  color: #000;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
  @media (min-width: 768px) {
    border-radius: 8px;
    height: 55px;
    font-size: 24px;
    margin-bottom: 30px;
    margin-top: 30px;
  }
}

// 四宫格容器样式 - 仅添加负边距修复布局偏移
.func-grid {
  display: flex;
  flex-wrap: wrap;
  margin: 16px 0;
  @media (min-width: 768px) {
    margin: 40px 0;
  }
}

// 四宫格每个格子样式 - 完全保留你的原始代码
.grid-item-search {
  // 2列布局，宽度50%，减去间距
  width: calc(50% - $gutter/2);
  height: 95px;
  border-radius: 10px;
  background: url('~@/assets/img/h5/home_search.png') center no-repeat;
  background-size: cover, contain; // 渐变覆盖整个格子，背景图完整显示
  // 内容居中
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    border-radius: 10px;
    height: 200px;
  }
}
.grid-item-myclub{
  width: calc(50% - $gutter/2);
  height: 95px;
  border-radius: 10px;
  background: url('~@/assets/img/h5/myclub.png') center no-repeat;
  background-size: cover, contain; // 渐变覆盖整个格子，背景图完整显示
  // 内容居中
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    border-radius: 10px;
    height: 200px;
  }
}
.grid-item-sale-manage{
  width: calc(50% - $gutter/2);
  height: 95px;
  border-radius: 10px;
  background: url('~@/assets/img/h5/sale_manage.png') center no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    border-radius: 10px;
    height: 200px;
  }
}
.grid-item-step{
  width: calc(50% - $gutter/2);
  height: 95px;
  border-radius: 10px;
  background: url('~@/assets/img/h5/step.png') center no-repeat;
  background-size: cover, contain; // 渐变覆盖整个格子，背景图完整显示
  // 内容居中
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    border-radius: 10px;
    height: 200px;
  }
}
.grid-item-register{
  width: calc(50% - $gutter/2);
  height: 95px;
  border-radius: 10px;
  background: url('~@/assets/img/h5/register.png') center no-repeat;
  background-size: cover, contain; // 渐变覆盖整个格子，背景图完整显示
  // 内容居中
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    border-radius: 10px;
    height: 200px;
  }
}
.grid-item-left{
  margin: 0 $gutter/2 $gutter/2 0;
}
.grid-item-right{
  margin: 0 0 $gutter/2 $gutter/2;
}

// 券码核销：独立成行占满宽度，黑底 + 散状金点 + 底部光晕，呼应扫码页主视觉
.grid-item-verify{
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 95px;
  border-radius: 10px;
  background: url('~@/assets/img/h5/hexiao.png') center no-repeat,
              linear-gradient(135deg, #1a1a1a 0%, #000 100%);
  background-size: cover, 100% 100%;
  border: 1px solid rgba($gold, 0.55);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 0 0 $gutter/2 0;
  // 内容浮于背景之上
  > * { position: relative; z-index: 1; }
  @media (min-width: 768px) {
    border-radius: 10px;
    height: 200px;
    gap: 20px;
  }
}

// 格子图标样式（保留你的原始代码，即使未使用）
.grid-icon {
  color: $gold;
  font-size: 24px;
  margin-bottom: 6px;
}

// 格子文字样式（保留你的原始代码）
.grid-text {
  color: #fff;
  font-size: 14px;
  @media (min-width: 768px) {
    font-size: 24px;
  }
}

// 公告入口
.notice-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #222;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  color: $gold;
  font-size: 14px;
  cursor: pointer;
  @media (min-width: 768px) {
    padding: 24px;
    font-size: 20px;
    margin-top: 24px;
  }
  span {
    margin-left: 8px;
  }
}

// 公告弹窗内容
.notice-content {
  padding: 20px;
  background: #1A1A1A;
  border-radius: 12px;
}

.notice-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  h3 {
    margin: 0;
    color: $gold;
    font-size: 18px;
    @media (min-width: 768px) {
      font-size: 24px;
    }
  }
  ::v-deep .van-icon {
    color: #999;
    font-size: 24px;
    cursor: pointer;
  }
}

.notice-body {
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 16px;
  h4 {
    margin: 0 0 12px 0;
    color: #fff;
    font-size: 14px;
    @media (min-width: 768px) {
      font-size: 18px;
    }
  }
  p {
    margin: 8px 0;
    color: #999;
    font-size: 13px;
    line-height: 1.6;
    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
}

::v-deep .van-popup {
  background: rgba(0, 0, 0, 0.8);
}

::v-deep .notice-content .van-button {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  color: #000;
  border: none;
  font-weight: bold;
}

.tel-link {
  color: $gold;
  text-decoration: underline;
}
</style>